"use client";

import React from "react";

import ImageAtom, { MagnoliaImage } from "@/components/atoms/image/image";
import withBrand from "@/components/with-brand";
import { ImageBannerProps } from "@/types/policy-document-types";

import Logo from "../../logo-component/logo";
import Styles from "../policy-document-section.module.css";

function ImageContent({
  policyDocumentImage,
  brand,
}: Readonly<ImageBannerProps>) {
  const imageProps: MagnoliaImage | undefined | null =
    typeof policyDocumentImage === "string"
      ? {
          "@id": "",
          "@link": policyDocumentImage,
          "@name": "",
          "@path": "",
          "@type": "",
          "@uuid": "",
        }
      : policyDocumentImage;

  const srcImage = `${process.env.NEXT_PUBLIC_MGNL_HOST}/dam/${imageProps?.["@id"]}${imageProps?.["@path"]}`;

  return (
    <div
      className="flex flex-col gap-spacing-m md:gap-spacing-l "
      data-testid="imageBanner-testid"
    >
      {imageProps && (
        <>
          {/* Avanti image */}
          <div className="hidden lg:block">
            <ImageAtom
              image={imageProps}
              altText="Policy Doc Banner"
              styleClass={`rounded-xl absolute inset-0 w-full ${brand} ${Styles.coverImageBannerHeight} object-cover `}
              data-testid="banner-image-testid"
            />
          </div>

          {/* Staysure image */}
          <div
            style={{
              backgroundImage: `url(${srcImage})`,
              backgroundRepeat: "no-repeat",
              zIndex: 1,
            }}
            className="flex lg:flex-col ml-[50%]
            !bg-cover flex-col-reverse lg:!bg-center !bg-right rounded-xl h-[88px] md:h-[175px] lg:hidden "
          />
        </>
      )}
      <div
        className={`absolute inset-0 lg:hidden block z-10 ${brand} ${Styles.coverImageBanner}`}
      >
        <div className="absolute inset-0 flex items-center lg:hidden z-10">
          <Logo
            color="primary"
            size="xl"
            className={`${brand} ${Styles.logo}`}
          />
        </div>
      </div>
    </div>
  );
}

export default withBrand(ImageContent);
